import { messageFormartError } from './utilsMessageErrors'

import { NotificationInfo } from '../components/Notifications/interfaces/notification'

import { addNotification } from '../components/Notifications/state/notificationsState'

import { store } from '@/core/store/store'

interface IProps {
  message?: string
  title?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ex?: any
  seRegistra?: boolean
  toastType?: 'info' | 'warning' | 'error' | 'success'
}

/**
 * muestra un toast con el mensaje correspondiente
 *  @params title?: string Opcional si define el titulo debe definir
 * el mensaje y el toastType
 *  @message?: string Opcional si define el mensaje debe definir
 * el title y toastType
 *  @ex?: any Es opcional pero si envia este parametro debe ser
 * la excepción del catch el cual mostrará si es un error un warning o un info.
 *  @seRegistra?: boolean  Se coloca en true, se registrará
 * el mensaje en la campana de notificaciones
 *  @emailDefault: string Si el correo que se desea enviar es
 * un correo determinado por el equipo de desarrollo
 *  @toastType?: string Se envia el tipo de toas a mostrar ejm info,
 *  warning, error si no envia texto se mostrará el success
 */
export const notifications = ({
  title = '',
  message = '',
  ex,
  toastType,
}: IProps): void => {
  if (title !== '' && message !== '') {
    const dataNotification: Omit<NotificationInfo, 'id'> = {
      title,
      message,
      style: toastType ?? 'success',
    }

    switch (toastType) {
      case 'info':
        addNewNotification({ ...dataNotification, style: 'info' })
        break

      case 'warning':
        addNewNotification({ ...dataNotification, style: 'warning' })
        break

      case 'error':
        addNewNotification({ ...dataNotification, style: 'error' })
        break

      default:
        addNewNotification({ ...dataNotification, style: 'success' })
        break
    }

    // seRegistra parameter is kept for backwards compatibility but no longer used
  }

  if (ex !== undefined) {
    const dataNotificationError: Omit<NotificationInfo, 'id'> = {
      title: 'Error',
      message: messageFormartError(ex),
      style: 'error',
    }

    if (ex.response === undefined) {
      addNewNotification(dataNotificationError)

      return
    }

    if (ex.response.status >= 200 && ex.response.status < 300) {
      addNewNotification(dataNotificationError)
    }
    if (ex.response.status >= 400 && ex.response.status < 500) {
      addNewNotification(dataNotificationError)
    }

    if (ex.response.status >= 500) {
      addNewNotification(dataNotificationError)
    }
  }
}

export const addNewNotification = (
  notification: Omit<NotificationInfo, 'id'>,
): void => {
  store.dispatch(
    addNotification({
      value: {
        message: notification.message,
        style: notification.style,
        title: notification.title ?? 'Reservas',
      },
    }),
  )
}
